import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isLollipop } from '@bubble-ui/particle-design-versions';
var getArrowContainerStyle = arrow => {
  var coordinates = {
    top: {
      top: 0,
      left: '50%'
    },
    'top-left': {
      top: 0,
      left: 5
    },
    'top-right': {
      top: 0,
      right: 10
    },
    right: {
      top: '50%',
      right: -7
    },
    'right-top': {
      top: 11.5,
      right: -7
    },
    'right-bottom': {
      bottom: 17.5,
      right: -7
    },
    bottom: {
      bottom: 0,
      left: '50%'
    },
    'bottom-left': {
      bottom: 0,
      left: 10
    },
    'bottom-right': {
      bottom: 0,
      right: 5
    },
    left: {
      top: '50%',
      left: -7
    },
    'left-top': {
      top: 16.5,
      left: -7
    },
    'left-bottom': {
      bottom: 12.5,
      left: -7
    }
  };
  return _objectSpread({
    position: 'absolute',
    zIndex: 1
  }, arrow ? coordinates[arrow] : {});
};
var getArrowRotatorStyle = arrow => {
  var transformers = {
    top: {
      transform: [{
        translateX: -14.5
      }, {
        rotate: '180deg'
      }]
    },
    'top-left': {
      transform: [{
        rotate: '180deg'
      }]
    },
    'top-right': {
      transform: [{
        rotate: '180deg'
      }]
    },
    right: {
      transform: [{
        translateY: -7.5
      }, {
        rotate: '270deg'
      }]
    },
    'right-top': {
      transform: [{
        rotate: '270deg'
      }]
    },
    'right-bottom': {
      transform: [{
        rotate: '270deg'
      }]
    },
    bottom: {
      transform: [{
        translateX: -9.5
      }]
    },
    'bottom-left': {},
    'bottom-right': {},
    left: {
      transform: [{
        translateY: -3.5
      }, {
        rotate: '90deg'
      }]
    },
    'left-top': {
      transform: [{
        rotate: '90deg'
      }]
    },
    'left-bottom': {
      transform: [{
        rotate: '90deg'
      }]
    }
  };
  return _objectSpread({
    width: 25
  }, arrow ? transformers[arrow] : {});
};
export var getDefaultStyleSheet = _ref => {
  var {
    arrow,
    designVersion,
    designContext,
    inverse,
    isNotText,
    hasFluidWidth
  } = _ref;
  var inverseState = inverse ? 'inverse' : 'default';
  var backgroundColor = designContext.get('tooltip/background-color', {
    inverseState
  }).toString();
  var borderColor = designContext.get('tooltip/border-color', {
    inverseState
  }).toString();
  var textColor = designContext.get('tooltip/text-color', {
    inverseState
  }).toString();
  var textStyle = designContext.get('tooltip/text-style', {
    inverseState
  }).styles();
  var cornerRadius = designContext.get('tooltip/corner-radius').pixelValue;
  var borderRadius = isLollipop(designVersion) ? 0 : cornerRadius;
  return {
    mainStyle: _objectSpread(_objectSpread({
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      position: 'relative'
    }, hasFluidWidth ? {} : {
      maxWidth: 240
    }), arrow === 'top-left' || arrow === 'top' || arrow === 'top-right' ? {
      paddingTop: 10
    } : arrow === 'right-top' || arrow === 'right' || arrow === 'right-bottom' ? {
      paddingRight: 10
    } : arrow === 'bottom-left' || arrow === 'bottom' || arrow === 'bottom-right' ? {
      paddingBottom: 10
    } : arrow === 'left-top' || arrow === 'left' || arrow === 'left-bottom' ? {
      paddingLeft: 10
    } : {}),
    backgroundStyle: {
      paddingLeft: isNotText || hasFluidWidth ? 15 : 14,
      paddingRight: isNotText || hasFluidWidth ? 15 : 14,
      paddingTop: isNotText ? 10 : 20,
      paddingBottom: isNotText ? 10 : 20,
      backgroundColor,
      borderRadius,
      borderColor,
      borderWidth: 1,
      borderStyle: 'solid'
    },
    arrowContainerStyle: getArrowContainerStyle(arrow),
    arrowRotatorStyle: getArrowRotatorStyle(arrow),
    arrowBackgroundColor: backgroundColor,
    arrowBorderColor: borderColor,
    textStyle: _objectSpread(_objectSpread(_objectSpread({}, hasFluidWidth || ['left', 'left-top', 'left-bottom', 'right', 'right-top', 'right-bottom'].includes(arrow || '') ? {} : {
      paddingLeft: 5,
      paddingRight: 5
    }), {}, {
      color: textColor
    }, textStyle), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word',
      marginBottom: -10,
      marginTop: -10,
      textRendering: 'geometricPrecision'
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map